export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';
//# sourceMappingURL=constants.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/constants.js
// module id = 323
// module chunks = 3